const WEBHOOK_URL = process.env.REACT_APP_SHEETS_WEBHOOK_URL;

export async function syncToSheets(delivery) {
  if (!WEBHOOK_URL) return;
  try {
    const params = new URLSearchParams({
      id:      delivery.id || '',
      client:  delivery.client || '',
      phone:   delivery.phone || '',
      address: delivery.address || '',
      store:   delivery.store || '',
      amount:  delivery.amount || '',
      source:  delivery.source || '',
      status:  delivery.confirmation_status || 'new',
    });
    await fetch(`${WEBHOOK_URL}?${params.toString()}`, { mode: 'no-cors' });
  } catch (err) {
    console.warn('Sheets sync failed:', err);
  }
}
